import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[stickyClass]',
  standalone: false,
})
export class StickyClassDirective implements AfterViewInit, OnDestroy {
  private static readonly CSS_CLASS = 'is-sticky';

  @Input('stickyClass') stickyAbove?: HTMLElement | string;

  private get aboveElement(): HTMLElement | undefined {
    return this.stickyAbove instanceof HTMLElement ? this.stickyAbove : undefined;
  }

  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  private scrollContainer: HTMLElement | null;
  private resizeObserver?: ResizeObserver;

  private readonly scrollHandler = (): void => {
    if ((this.scrollContainer?.scrollTop ?? 0) > 0) {
      this.renderer.addClass(this.el.nativeElement, StickyClassDirective.CSS_CLASS);
    } else {
      this.renderer.removeClass(this.el.nativeElement, StickyClassDirective.CSS_CLASS);
    }
  };

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'position', 'sticky');

    this.scrollContainer = document.getElementById('main-sidenav-content');
    this.scrollContainer?.addEventListener('scroll', this.scrollHandler, { passive: true });

    const above = this.aboveElement;
    if (above) {
      this.renderer.setStyle(this.el.nativeElement, 'z-index', '10');
      this.resizeObserver = new ResizeObserver(() => this.updateTop());
      this.resizeObserver.observe(above);
      this.updateTop();
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'z-index', '11');
      this.renderer.setStyle(this.el.nativeElement, 'top', '0px');
    }

    this.scrollHandler();
  }

  ngOnDestroy(): void {
    this.scrollContainer?.removeEventListener('scroll', this.scrollHandler);
    this.resizeObserver?.disconnect();
  }

  private updateTop(): void {
    this.renderer.setStyle(this.el.nativeElement, 'top', `${this.aboveElement?.offsetHeight ?? 0}px`);
  }
}
